import { Participant } from '~teacher/components/ResultsGrid/ResultsTable';
import {
  QuestionScore,
  Student,
  StudentActivityResponse,
} from '~teacher/models/activities';
import { QuizAnswer, QuizQuestion } from '~teacher/models/quizzes';

import { populateParticipants } from './mapStudentResponses';
import { NormalizedQuestion } from './normalizeQuestions';
import { NormalizedResponse } from './normalizeResponses';
import { NormalizedStudent } from './normalizeStudent';

export interface ParsedQuestionResultData {
  question: QuizQuestion;
  responses: StudentActivityResponse[];
  answers: QuizAnswer[];
  participants: Participant[];
  students: Record<string, Student>;
}

export function parseQuestionData({
  answers,
  questions,
  responses,
  students,
  questionPosition,
  questionScores,
}: {
  answers: Record<string, QuizAnswer>;
  questions: NormalizedQuestion;
  responses: NormalizedResponse;
  students: NormalizedStudent;
  questionPosition: number;
  questionScores: Record<number, QuestionScore>;
}): ParsedQuestionResultData {
  const questionId = questions.byOrder[questionPosition - 1];
  const question = questions.entities[questionId];

  if (!question) {
    return {
      question: undefined,
      responses: [],
      answers: [],
      participants: [],
      students: {},
    };
  }

  const participants = populateParticipants({
    answers,
    questions,
    responses,
    students,
    questionScores,
  });
  const questionResponses = [...(responses.byQuestionId[questionId] ?? [])].map(
    (responseId: number) => responses.entities[responseId]
  );
  const questionAnswers = question.answers.map((answerId) => answers[answerId]);

  return {
    question,
    responses: questionResponses,
    answers: questionAnswers,
    participants,
    students: students.entities,
  };
}
